module.exports = __webpack_public_path__ + "static/media/Priya.302b1e30.jpg";